import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";
import { useNavigate } from "react-router-dom";

const useMainProfile = (userToken) => {
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [userMainData, setUserMainData] = useState([]);

  useEffect(() => {
    const fetchUserMainData = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/profile/main`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setUserMainData(response.data);
      } catch (error) {
        console.log("Error during main profile data request", error);

        console.log("error:", error);
        if (error.response?.status === 401) {
          console.log("401 dad:");
          localStorage.removeItem("token");
          navigate("/login");
        }
      }
    };
    if (userToken) {
      fetchUserMainData();
    }
  }, [baseUrl, userToken]);

  return { userMainData };
};

export default useMainProfile;
